import { ApolloClient, ApolloError, InMemoryCache, createHttpLink, from } from '@apollo/client'
import { RetryLink } from '@apollo/client/link/retry'
import { setContext } from '@apollo/client/link/context'
import { onError } from '@apollo/client/link/error'
// @ts-expect-error TS(2306) FIXME: File '/Users/cedric/dev/saas-nx/workspace/dist/lib... Remove this comment to see the full error message
import ToktokdocLib from '@saas/lib/toktokdoc-lib/web'

// Type must be augmented because of https://github.com/apollographql/apollo-link/issues/536
type NetworkError = ApolloError & { result: { error: string } }

const httpLink = createHttpLink({
    uri: `${(window as any)._env_.REACT_APP_API_URL}/graphql`,
})

const authLink = setContext(async (_, { headers }) => ({
    headers: {
        ...headers,
        'X-Parse-Session-Token': window.localStorage.getItem('sessionToken'),
        'X-Parse-Application-Id': (window as any)._env_.REACT_APP_PARSE_APPLICATION_ID,
    },
}))

// basic error link
const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
        graphQLErrors.forEach(({ message, locations, path }) =>
            console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`),
        )
    }
    if (networkError) {
        const error = networkError as NetworkError
        if (error.result && error.result.error === 'Session token is expired.') {
            ToktokdocLib.Auth.LogOut()
            const hds = window._env_.REACT_APP_HDS_HOST
            const auth = window._env_.REACT_APP_CUR_AUTH_CLBC
            window.location.href = `${hds}/login?redirect=${auth}`
        }

        console.log(`[Network error]: ${networkError}`)
    }
})

const retryLink = new RetryLink()

const appLink = from([authLink, retryLink, errorLink, httpLink])

const apolloClient = new ApolloClient({
    link: appLink,
    cache: new InMemoryCache({
        typePolicies: {},
    }),
})

export default apolloClient
